import { jsx as _jsx } from "react/jsx-runtime";
import { Link, useLocation } from "react-router-dom";
import useAccount from "src/features/account/hooks/useAccount";
import { useAppSelector } from "src/app/store/hooks";
import { selectUsagesById, useGetUsagesQuery } from "src/features/sidebar/sidebarSlice";
import { ACCOUNT_USAGE_NAME_AI_ANALYSIS_COUNT } from "src/features/auth/config/accountUsages";
import { Anchor, Text } from "@mantine/core";
import { Trans } from "react-i18next";
const AiInsightsRemainingMessage = () => {
    const location = useLocation();
    const { upgradeAccount } = useAccount();
    const { isLoading: isLoadingUsages } = useGetUsagesQuery(location.pathname);
    const accountUsagesAi = useAppSelector(state => selectUsagesById(state, location.pathname, ACCOUNT_USAGE_NAME_AI_ANALYSIS_COUNT));
    const { currentUsage, ceiling } = accountUsagesAi;
    const remaining = ceiling - currentUsage;
    const handlePlanUpgrade = (e) => {
        e.preventDefault();
        upgradeAccount();
    };
    if (isLoadingUsages || remaining < 0) {
        return null;
    }
    return (_jsx(Text, { children: _jsx(Trans, { i18nKey: 'infos:Ai.insights.remaining_', values: {
                remaining,
                ceiling,
            }, components: [
                _jsx(Anchor, { component: Link, c: "teal", underline: "always", to: "#", onClick: handlePlanUpgrade })
            ] }) }));
};
export default AiInsightsRemainingMessage;
